import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  containerCode: {
    width: '100%',
    alignItems: 'flex-end',
  },
  codeText: {
    fontSize: 12,
  },
  containerTitleDescription: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerTitle: {
    padding: 10,
  },
  titleText: {
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  containerDescription: {
    width: '100%',
    paddingHorizontal: 10,
  },
  descriptionText: {
    fontSize: 11,
  },
});
